var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Train',{scopedSlots:_vm._u([{key:"train",fn:function(){return _vm._l((_vm.taktareas),function(taktarea,taktarea_index){return _c('MPTaktarea',{key:`taktarea${taktarea.id}`,attrs:{"project_id":_vm.project.id,"train":_vm.train,"train_index":_vm.train_index,"taktarea":taktarea,"taktarea_index":taktarea_index}})})},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }